import styled  from "styled-components";

export const Logo = styled.img`
position : static;
width : 100%;
z-index:2;
`